import { Route, Routes } from "react-router-dom";
import AboutMe from "./components/About/AboutMe";
import Blogs from "./components/Blogs/Blogs";
import Footer from "./components/Footer";
import Header from "./components/Header/Header";
import Home from "./components/Home/Home";
import NotFound from "./components/Notfound/NotFound";
import ProjectDetails from "./components/ProjectDetails/ProjectDetails";
import AOS from 'aos';
import 'aos/dist/aos.css'; 
AOS.init();
function App() {
  return (
    <div>
      <Header />
      <Routes>
        <Route path='/' element={<Home></Home>}></Route>
        <Route path='project/:id' element={<ProjectDetails></ProjectDetails>}></Route>
        <Route path='/about' element={<AboutMe></AboutMe>}></Route>
        <Route path='/blog' element={<Blogs></Blogs>}></Route>
        <Route path='*' element={<NotFound></NotFound>}></Route>
      </Routes>
      <Footer/>
    </div>
  );
}

export default App;
